import Switch from "react-switch";
import { useDatabase } from '../../contexts/DatabaseContext';

export default function VisualizerSettings({ config, setConfig, workspaceId, workspaceType }) {

    const { updateWorkspaceConfigDoc, createVisualizerActionEvent } = useDatabase();

    const handleToggleVisualizer = async () => {
        try {
            const visualizerEnabled = !config.visualizerEnabled;
            setConfig(prev => ({ ...prev, visualizerEnabled }));
            await updateWorkspaceConfigDoc(workspaceId, { visualizerEnabled });
            createVisualizerActionEvent(workspaceType, workspaceId, visualizerEnabled);
        } catch (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: error.code,
                    message: error.message,
                    action: "visualizer",
                }
            }));
        }
    }

    return (
        <div className="input-settings-group-inner">
            <p className="settings-input-description">This is the setting for the visualizer that will be displayed to the user.</p>
            <div className="settings-check">
                <Switch 
                onColor="#27ca52"
                className="settings-check-input" 
                checked={config?.visualizerEnabled}
                onChange={handleToggleVisualizer}
            />
                <label className="settings-check-label">Enable Visualizer</label>
            </div>
        </div>
    )
}
